// store/slices/authInitSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { checkAuthStatus } from "./authSlice";

const authInitSlice = createSlice({
  name: "authInit",
  initialState: {
    initialized: false,
  },
  /**
   * `initialized` is set by `checkAuthStatus` settling, either way — it means
   * "the session question has been asked and answered", not "there is a
   * session". `ProtectedRoute` blocks on it so a signed-in user is never
   * bounced to /login during the boot round-trip.
   *
   * There is deliberately no plain action that flips it. One existed for the
   * design preview, to seed a session without a backend; it went with the
   * preview. Anything that sets this without asking the server reintroduces
   * exactly that bypass.
   */
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthStatus.fulfilled, (state) => {
        state.initialized = true;
      })
      .addCase(checkAuthStatus.rejected, (state) => {
        state.initialized = true;
      });
  },
});

export const selectAuthInitialized = (state) => state.authInit.initialized;

export default authInitSlice.reducer;
